/**
 * App version shown in the login / about surfaces. Format: `v{YYYYMMDD}.{major}.{minor}.{patch}`.
 * Bump the date for any release; bump the trailing trio by feature/fix scope.
 */
export const APP_VERSION = 'v20261104.1.15.1';